var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 5,
    fill: "#F3F5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89548 8.77771C4.2548 8.66064 4.45143 8.27431 4.33461 7.9145C4.21778 7.55469 3.83192 7.35783 3.47259 7.47466C3.1135 7.59173 2.91688 7.97806 3.03371 8.33787C3.15054 8.69767 3.53639 8.89454 3.89548 8.77771Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38821 6.54265C5.63262 6.46309 5.76617 6.20029 5.68685 5.95564C5.60754 5.711 5.34497 5.57719 5.10079 5.65675C4.85662 5.73607 4.72283 5.99889 4.80215 6.24354C4.88171 6.48819 5.14404 6.62221 5.38821 6.54265Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7244 9.21255C31.1482 8.82456 31.1779 8.16586 30.7903 7.74154C30.4031 7.31699 29.7456 7.28736 29.3217 7.67512C28.8979 8.06312 28.8683 8.72181 29.2555 9.14637C29.6428 9.57068 30.3006 9.60031 30.7244 9.21255Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4693 14.9738L25.9006 27.0027C25.7364 27.4139 25.2713 27.6057 24.8883 27.4411L13.261 22.8651C12.8505 22.7008 12.6592 22.2351 12.8233 21.8514L18.8695 6.45213C19.0337 6.04119 19.4988 5.84934 19.8818 6.01371L28.3081 9.32938L30.4693 14.9738Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7214 18.7004L25.5178 18.2345C25.4084 18.207 25.3809 18.0976 25.4084 17.9879C25.4356 17.8782 25.545 17.851 25.6547 17.8783L26.8583 18.3441C26.9677 18.3716 26.9952 18.481 26.9677 18.5907C26.9405 18.7004 26.8308 18.7278 26.7214 18.7004Z",
    fill: "#E3EAF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3089 9.32913L27.023 12.6173C26.8314 13.0832 27.1052 13.6313 27.5429 13.7957L30.4701 14.9465",
    fill: "#E6EDF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5558 9.79501L22.8908 21.4952C23.0549 21.9061 22.8908 22.372 22.4804 22.5364L11.0447 27.5782C10.6342 27.7426 10.169 27.5782 10.0049 27.167L3.35684 12.042C3.1927 11.6308 3.35684 11.1652 3.7673 11.0008L12.057 7.32892L17.5558 9.79501Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7019 10.4528L6.20274 12.8639C6.06608 12.9188 5.92919 12.8639 5.87448 12.727C5.81977 12.5899 5.87448 12.453 6.01138 12.3983L11.483 9.98688C11.6197 9.93216 11.7566 9.98688 11.8113 10.1238C11.866 10.2609 11.8113 10.3978 11.7019 10.4528Z",
    fill: "#CED7E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88348 13.2751L6.77698 14.2066C6.64008 14.2613 6.50341 14.2066 6.4487 14.0697C6.39399 13.9326 6.44871 13.7957 6.58537 13.7407L8.69212 12.8092C8.82878 12.7545 8.96567 12.8092 9.02038 12.9461C9.07509 13.0557 9.02038 13.2201 8.88348 13.2751Z",
    fill: "#CED7E2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9548 10.6993L26.1465 27.1398C26.1465 27.6879 25.7088 28.1535 25.1342 28.1535H9.18416C8.63704 28.1535 8.17188 27.7151 8.17188 27.1398V6.01371C8.17188 5.46564 8.60957 5 9.18416 5H20.7567L25.9548 10.6993Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3281 24.8656H10.9358C10.7989 24.8656 10.6895 24.7559 10.6895 24.6188C10.6895 24.4819 10.7989 24.3722 10.9358 24.3722H14.3281C14.465 24.3722 14.5745 24.4819 14.5745 24.6188C14.5745 24.7559 14.465 24.8656 14.3281 24.8656Z",
    fill: "#E3EAF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7601 8.45253H11.0997C10.9356 8.45253 10.7715 8.31539 10.7715 8.12354C10.7715 7.95917 10.9081 7.7948 11.0997 7.7948H18.7601C18.9242 7.7948 19.0884 7.93169 19.0884 8.12354C19.0609 8.31539 18.9242 8.45253 18.7601 8.45253Z",
    fill: "#CED7E2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0269 10.2884H11.0997C10.9356 10.2884 10.7715 10.1513 10.7715 9.95942C10.7715 9.79504 10.9081 9.63068 11.0997 9.63068H14.0269C14.1911 9.63068 14.3555 9.76781 14.3555 9.95942C14.328 10.1513 14.1911 10.2884 14.0269 10.2884Z",
    fill: "#CED7E2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7568 5.02722V9.54845C20.7568 10.1787 21.304 10.6993 21.9333 10.6993H25.9549",
    fill: "#E6EDF5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4384 13.7407H19.4442C19.4442 13.7407 19.4442 13.7407 19.4167 13.7407C19.4167 13.7407 19.4167 13.7407 19.3895 13.7407H15.2856C15.2856 13.7407 15.2856 13.7407 15.2582 13.7407C15.2582 13.7407 15.2581 13.7407 15.2309 13.7407H11.3734C10.9357 13.7407 10.6074 14.097 10.6074 14.5354V21.4952C10.6074 21.9336 10.9629 22.2898 11.3734 22.2898H23.4111C23.8488 22.2898 24.1771 21.9336 24.1771 21.4952V14.5354C24.2043 14.097 23.8488 13.7407 23.4384 13.7407ZM15.5045 19.906V18.3441H19.1979V19.906H15.5045ZM19.1979 20.3718V21.824H15.5045V20.3718H19.1979ZM19.1979 16.289V17.8508H15.5045V16.289H19.1979ZM15.5045 15.8234V14.2066H19.1979V15.8234H15.5045ZM23.7394 17.8508H19.663V16.289H23.7394V17.8508ZM15.0393 17.8508H11.0723V16.289H15.0121V17.8508H15.0393ZM11.0723 18.3441H15.0121V19.906H11.0723V18.3441ZM19.663 18.3441H23.7394V19.906H19.663V18.3441ZM23.7394 14.5354V15.8234H19.663V14.2066H23.4384C23.6025 14.2066 23.7394 14.3435 23.7394 14.5354ZM11.3734 14.2066H15.0121V15.8234H11.0723V14.5354C11.0723 14.3435 11.2092 14.2066 11.3734 14.2066ZM11.0723 21.4952V20.3718H15.0121V21.824H11.3734C11.2092 21.824 11.0723 21.6871 11.0723 21.4952ZM23.4384 21.824H19.663V20.3718H23.7394V21.4952C23.7394 21.6871 23.6025 21.824 23.4384 21.824Z",
    fill: "#E3EAF2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6447 14.1244C22.3711 14.1244 21.7146 13.8778 21.4957 13.7957C20.3465 13.2751 18.4589 11.7405 17.4193 11.7405C16.3796 11.7405 14.4919 13.2476 13.343 13.7957C13.1514 13.8778 12.4673 14.1244 12.1938 14.1244C11.7561 14.1519 11.4278 14.5353 11.4825 14.9465C11.592 15.9602 11.8655 17.7686 12.5768 20.0978C13.5071 22.9748 16.0788 24.7012 17.0636 25.2765C17.3099 25.4134 17.5835 25.4134 17.8296 25.2765C18.8146 24.7012 21.3863 22.9748 22.2617 20.0978C22.9729 17.7686 23.2467 15.9602 23.3562 14.9465C23.4109 14.5081 23.0823 14.1244 22.6447 14.1244Z",
    fill: "url(#paint0_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8796 15.4122C21.7977 16.0699 21.6333 17.0836 21.3051 18.3442C21.2503 18.5632 21.1956 18.81 21.1137 19.0291C21.059 19.2484 21.0043 19.4401 20.9221 19.6594C20.2381 21.8514 18.3504 23.2214 17.4203 23.7694C17.4203 23.7694 17.4203 23.7694 17.3928 23.7694C17.3928 23.7694 17.3928 23.7694 17.3656 23.7694C17.2834 23.7147 17.2014 23.6598 17.092 23.6051C16.107 22.9476 14.5203 21.6596 13.9183 19.6869C13.7816 19.221 13.6447 18.7826 13.5353 18.3442C13.207 17.0836 13.0429 16.0699 12.9609 15.4122C13.4259 15.33 13.9457 15.1109 14.0552 15.056C14.4656 14.8643 14.958 14.5628 15.4504 14.2613C15.9976 13.9326 16.9551 13.3298 17.3381 13.2751C17.3381 13.2751 17.3381 13.2751 17.3656 13.2751C17.3656 13.2751 17.3656 13.2751 17.3928 13.2751C17.7486 13.2751 18.7608 13.9051 19.3354 14.2613C19.8278 14.5628 20.3203 14.8643 20.7307 15.056C20.8948 15.1109 21.4145 15.33 21.8796 15.4122Z",
    fill: "url(#paint1_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7907 14.2613L17.3926 13.2751L21.5511 17.4399L19.1983 21.9883L17.8302 22.5914L13.5625 18.3442L14.3012 17.6864L16.736 14.3435L16.7907 14.2613Z",
    fill: "url(#paint2_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.392 13.2751V18.3167H13.5619C13.2336 17.0564 13.0695 16.0424 12.9873 15.3849C13.4525 15.3028 13.9721 15.0834 14.0815 15.0287C14.492 14.8369 14.9844 14.5354 15.4768 14.2341C16.0514 13.9326 17.009 13.3298 17.392 13.2751Z",
    fill: "url(#paint3_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3048 18.3441C21.2501 18.5632 21.1954 18.81 21.1134 19.0291C21.0587 19.2484 21.004 19.44 20.9218 19.6593C20.2378 21.8514 18.3501 23.2213 17.4201 23.7694C17.4201 23.7694 17.4201 23.7694 17.3926 23.7694V18.3441H21.3048Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.7709,
    y1: 15.9533,
    x2: 20.6323,
    y2: 21.3626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20.6574,
    y1: 21.3586,
    x2: 15.3484,
    y2: 14.6085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 16.1557,
    y1: 15.6162,
    x2: 18.4624,
    y2: 19.3268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#657EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 13.0069,
    y1: 15.8095,
    x2: 17.412,
    y2: 15.8095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 19.8897,
    y1: 21.5757,
    x2: 16.899,
    y2: 18.5895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/taskIcon.286b92dadecd7c8da1b89c992e2901e5.svg";
export { ForwardRef as ReactComponent };